(function () {
    'use strict';

    angular
        .module('app.clubAdmin')
        .component('sc3ClubViewForm', {
            templateUrl: 'app/club-admin/club-info/club-view-form.component.html',
            controller: ClubViewFormComponent,
            bindings: { model: '<' }
        });

    ClubViewFormComponent.$inject = ['defaultClubLogoUrl', 'user'];
    function ClubViewFormComponent(defaultClubLogoUrl, user) {
        // Variables
        var ctrl = this;

        // Properties
        Object.defineProperty(ctrl, 'club', { get: getClub });
        ctrl.defaultClubLogo = defaultClubLogoUrl;
        ctrl.isHandicapChair = user.isHandicapChair;
        ctrl.edit = edit;

        /////////////////////////////////
        function edit() {
            ctrl.model.isEditing = true;
        }
        function getClub() {
            return ctrl.model.club;
        }
    }
})();